import "./ModalWait.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import Modal from "react-bootstrap/Modal";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Spinner from "react-bootstrap/Spinner";

function ModalWait(props) {

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static" 
            keyboard={false}   
            onExited={props?.onExited}
        >
            <Modal.Body>
                <div className="headBody">
                    <Row>
                        <Col md={12} sm={12} style={{ fontSize: "14px" }}>
                            <p style={{ textAlign: "center" }}>A aguardar resposta do servidor...</p>
                        </Col>
                    </Row>
                    <Row>
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default ModalWait;
